import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

function AppBar_6({ customization, searchBarPlaceholder }) {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);

  const appBarFilter = useMemo(() => HexToHueConverter(customization?.textColor), [customization?.textColor]);

  const appBarSearchIconFilter = useMemo(
    () => HexToHueConverter(customization?.searchBarIconColor),
    [customization?.searchBarIconColor],
  );

  const appBarItems = useMemo(() => {
    return customization?.items_4?.map((appBarItem, index) => {
      const isLogo = appBarItem?.id === 'logo';
      const logoAlignmentClass = isLogo ? 'w-full flex items-center ' : '';
      const logoClass = isLogo
        ? customization?.logoPosition === 'left'
          ? 'mr-auto'
          : customization?.logoPosition === 'right'
          ? 'ml-auto'
          : 'left-[50%] translate-x-[-50%] absolute'
        : `max-h-[17.946px] max-w-[17.946px] 2xl:max-h-[20px] 2xl:max-w-[20px]`;

      const logoStyle = isLogo
        ? { height: '40px', width: '100px', objectFit: 'contain' }
        : { filter: appBarFilter, width: customization?.buttonSize, height: customization?.buttonSize };

      return (
        <div className={logoAlignmentClass} key={appBarItem?.id || index}>
          {!isLogo && index === 0 ? (
            <div>
              <img style={logoStyle} className={logoClass} src={appBarItem?.url} alt="bottom bar icon" />
            </div>
          ) : !isLogo ? (
            <div
              style={{
                backgroundColor: customization?.textBackgroundColor,
                borderRadius: '50%',
                padding: '5px',
              }}
            >
              <img style={logoStyle} className={logoClass} src={appBarItem?.url} alt="bottom bar icon" />
            </div>
          ) : (
            <img style={logoStyle} className={logoClass} src={appBarItem?.url} alt="bottom bar icon" />
          )}
        </div>
      );
    });
  }, [customization?.items_4, customization?.logoPosition, appBarFilter]);

  return (
    <div className="flex flex-col">
      <div className="flex flex-row w-full items-center relative gap-[7.5px]" style={{ height: staticValues[40] }}>
        {appBarItems}
      </div>
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: customization?.searchBarIconAlignment === 'right' ? 'row' : 'row-reverse',
            alignItems: 'center',
            justifyContent: customization?.searchBarIconAlignment === 'right' ? 'space-between' : 'left',
            width: '100%',
            padding: customization?.padding,
            border: `1px solid ${customization?.searchBarBorderColor}`,
            borderRadius: customization?.searchBarBorderRadius,
            backgroundColor: customization?.searchBarBackgroundColor,
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontSize: customization?.searchBarTextSize,
              color: customization?.searchBarTextColor,
              fontWeight: customization?.searchBarTextWeight,
              fontStyle: customization?.searchBarTextStyle,
            }}
          >
            {searchBarPlaceholder}
          </div>
          <div>
            <img
              src="https://d9aff4nz0lkg0.cloudfront.net/icon/png/0998eed7-3306-4a2f-877e-317a3cd05ffb.png"
              alt={'search icon'}
              className={`w-full   ${customization?.searchBarIconAlignment === 'right' ? 'ml-auto' : 'mr-2'}`}
              style={{
                filter: appBarSearchIconFilter,
                width: customization?.searchBarIconSize,
                height: customization?.searchBarIconSize,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppBar_6;
